import { useEffect, useRef } from "react";

export function PartytownGoogleTagManager(props: {
  gtmContainerId: string | undefined;
  dataLayerKey?: string;
}) {
    const init = useRef(false);
    const {gtmContainerId, dataLayerKey = 'dataLayer'} = props;

  useEffect(() => {
    if (init.current || !gtmContainerId) {
      return;
    }

    // Check URL for debug parameter to temporarily disable Partytown for testing
    const isDebugMode = typeof window !== 'undefined' && 
        (window.location.search.includes('gtm_debug=1') || 
        window.location.search.includes('gtm_preview='));

    const gtmScript = document.createElement('script');
    const nonceScript = document.querySelector('[nonce]') as
      | HTMLScriptElement
      | undefined;
    if (nonceScript?.nonce) {
      gtmScript.setAttribute('nonce', nonceScript.nonce);
    }
    gtmScript.innerHTML = `
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
          ${isDebugMode ? '' : 'j.type = "text/partytown"'}
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl + 
                ${isDebugMode ? 
                "'&version=' + Date.now()" :  // Removed hardcoded auth/preview params
                "'&version=' + Date.now()"};
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', '${dataLayerKey}', '${gtmContainerId}');
    `;

    // Add the partytown GTM script to the body
    document.body.appendChild(gtmScript);

    init.current = true;
    return () => {
      document.body.removeChild(gtmScript);
    };
  }, [dataLayerKey, gtmContainerId]);

  if (!gtmContainerId) {
    return null;
  }

  return (
    <noscript>
      {/* GOOGLE TAG MANAGER NO-JS FALLBACK */}
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmContainerId}`}
        height="0"
        width="0"
        style={{display: 'none', visibility: 'hidden'}}
      />
    </noscript>
  );
}